// Copyright (c) Docugami, Inc. All rights reserved.

import { EntryTitleCell } from 'components/reports/ReportGridEntryTitleCell';
import { ReportEntry } from 'networking/reportsApi';
import React from 'react';
import { IReportGroup } from 'store/reports/selectors';
import { AutomationId } from 'utils/Automation';

// Replace with actual ag-grid types once we start https://classifyprocess.visualstudio.com/product/_workitems/edit/20723
interface AgGridEntityColumnHeaderProps {
    entryIndex: number;
    canRemoveEntry: boolean;
    onRemoveEntry: (entry: ReportEntry) => void;
    showEntryConfirmation: boolean;
    isLocked: boolean;
    entry: ReportEntry;
    columnGroups: IReportGroup[];
};

const AgGridEntityColumnHeader: React.FC<AgGridEntityColumnHeaderProps> = (props: AgGridEntityColumnHeaderProps) => {
    return (
        <EntryTitleCell
            entryIndex={props.entryIndex}
            automationId={AutomationId.WorkPathGridDocumentEntryTitleCell}
            canRemoveEntry={props.canRemoveEntry}
            onRemoveEntry={props.onRemoveEntry}
            showEntryConfirmation={props.showEntryConfirmation}
            isLocked={props.isLocked}
            entry={props.entry}
            columnGroups={props.columnGroups}
        />
    );
};

export default AgGridEntityColumnHeader;
